interface EnvConfig {
  hotelxNodeUrl: string
  redirectUrl: string
}

declare global {
  interface Window {
    __APP_ENV__?: string
  }
}

const environmentConfigs: Record<string, EnvConfig> = {
  local: {
    hotelxNodeUrl: 'http://localhost:8000/hotelx',
    redirectUrl: 'http://localhost:3306',
  },
  dev: {
    hotelxNodeUrl: 'https://hotelx-dev-api.ifca.io/hotelx',
    redirectUrl: 'https://hotelx-palace.ifca.io',
  },
  uat: {
    hotelxNodeUrl: 'https://hotelx-uat-api.ifca.io/hotelx',
    redirectUrl: 'https://ifcapalace-uat.ifca.io',
  },
  prod: {
    hotelxNodeUrl: 'https://hotelxapi.hotelx.asia/hotelx',
    redirectUrl: 'https://miranihotel.hotelx.asia',
  },
  'hms1-prod': {
    hotelxNodeUrl: 'https://hotelx1api.hotelx.asia/hotelx',
    redirectUrl: 'https://miranihotel.hotelx.asia',
  }
}

/**
 * Get the current environment name.
 * An unknown name falls back to local, never to uat or prod.
 */
export function getCurrentEnv(): string {
  // Priority 1: Build-time environment variable
  const buildTimeEnv = process.env.REACT_APP_ENV
  if (buildTimeEnv && environmentConfigs[buildTimeEnv]) {
    return buildTimeEnv
  }

  // Priority 2: Runtime configuration from config.js
  if (
    typeof window !== 'undefined' &&
    window.__APP_ENV__ &&
    environmentConfigs[window.__APP_ENV__]
  ) {
    return window.__APP_ENV__
  }

  // Default: local
  return 'local'
}

/** Live payment amount for every deployed env. local / dev send RM 1. */
export function isProdOrUat(): boolean {
  const env = getCurrentEnv()
  return env !== 'local' && env !== 'dev'
}

/** Prod-tier OCR / hostname rules for every non-UAT deployed env. */
export function isProd(): boolean {
  const env = getCurrentEnv()
  return isProdOrUat() && !env.includes('uat')
}

export function getEnvConfig(): EnvConfig {
  return environmentConfigs[getCurrentEnv()]
}
